import styled from 'styled-components';
import { checkPixel, hexToRGB } from 'utils';

export const Container = styled.header`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 104px;
  white-space: pre;
  z-index: 100;
  transition: all 150ms ease;
  background-color: ${({ $scrollPosition, $sub }) => (($scrollPosition > 1 || $sub) && 'white') || 'transparent'};

  &:hover {
    background-color: white;
    h3 {
      color: ${({ theme }) => theme.colors.strong};
    }
  }
`;

export const Wrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1432px;
  margin: 0 auto;
  padding: 0 20px;

  h1,
  h2 {
    display: none;
  }

  img {
    z-index: 20;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 29px 24px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding: 32px 24px;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;
  height: 100%;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 16px;
  }
`;

export const MenuList = styled.ul`
  display: flex;
  gap: 32px;
  height: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`;

export const MenuListItem = styled.li`
  position: relative;
  overflow: hidden;
  height: 100%;

  h3 {
    color: ${({ $scrollPosition, theme, $sub }) => (($scrollPosition > 1 || $sub) && theme.colors.strong) || 'white'};
    font-size: 20px;
    line-height: 1.5;
  }

  h4 {
    font-size: 14px;
    line-height: 1;
    font-weight: 500;
  }

  & > a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 102px;
    height: 100%;
    padding: 0 16px;
    transition: all 150ms ease;

    &:hover {
      opacity: 0.6;
    }
  }

  & > ul {
    width: 116px;
    position: absolute;
    overflow: hidden;
    top: 104px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 0;
      height: 4px;
      background-color: ${({ theme }) => theme.colors.primary};
      transition: all linear 150ms;
    }

    &::before {
      left: 38%;
    }
    &::after {
      right: 50%;
    }

    & > li > a {
      padding: 22px 32px;
      &:hover {
        opacity: 0.6;
      }
    }
  }

  &:hover {
    overflow: unset;
    & > ul {
      top: 100px;
      width: fit-content;
      height: ${({ $count }) => checkPixel($count * 58)};
      background-color: white;
    }
    & > ul::before,
    & > ul::after {
      width: 50%;
    }
  }

  ${({ $active, theme }) => $active && `border-bottom: 4px solid ${theme.colors.primary}`};
  .active {
    h3 {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const NavUl = styled.ul``;

export const NavListItem = styled.li`
  background-color: ${({ $active }) => $active && 'red'};
`;

export const LangBox = styled.div`
  position: relative;
  cursor: pointer;
  transition: all 150ms ease;
  z-index: 20;
  overflow: hidden;
  p {
    color: ${({ $scrollPosition, $hover, open, $main, theme }) =>
      (($scrollPosition > 1 || $hover || open || !$main) && theme.colors.strong) || 'white'};
  }

  & > div:nth-child(1) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 37px 18px;
  }

  & > div:nth-child(2) {
    background-color: ${({ theme }) => hexToRGB(theme.colors.white, 0.52)};
    position: absolute;
    padding: 14px 32px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 0;
      height: 4px;
      background-color: ${({ theme }) => theme.colors.primary};
      transition: all linear 150ms;
    }
    &::before {
      left: 50%;
    }
    &::after {
      right: 50%;
    }
  }

  &:hover {
    overflow: unset;
    & > div:nth-child(2) {
      &::before,
      &::after {
        width: 50%;
      }
    }
  }

  @media ${({ theme }) => theme.device.tablet} {
    & > div:nth-child(1) {
      padding: 37px 16px;
    }
  }
`;

export const MoBox = styled.div`
  display: none;
  position: relative;
  z-index: 20;

  @media ${({ theme }) => theme.device.tablet} {
    cursor: pointer;
    padding: 8px;
    display: block;
  }
`;

export const MoContainer = styled.div`
  display: none;

  @media ${({ theme }) => theme.device.tablet} {
    display: block;
    position: absolute;
    z-index: 15;
    top: 0;
    right: ${({ open }) => (open && `0`) || `-100vw`};
    width: 100vw;
    height: 100vh;
    background-color: white;
    border-left: 1px solid ${({ theme }) => theme.colors.primary};
    transition: all 200ms cubic-bezier(0.25, 0.25, 0.75, 0.75);
  }
`;

export const MoWrap = styled.div`
  margin: 104px 24px 0;
`;

export const MoList = styled.ul``;

export const MoListItem = styled.li`
  width: 100%;
  ${({ open, theme }) => !open && `border-bottom:1px solid ${hexToRGB(theme.colors.strong, 0.03)}`};

  & > div {
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const MoSubList = styled.ul`
  ${({ open, theme }) => open && `border-top:2px solid ${theme.colors.primary}`};
  background-color: ${({ theme }) => theme.colors.fill12};
  height: ${({ open, $count }) => (open && checkPixel($count * 58)) || '0'};
  overflow: hidden;
  transition: all 200ms cubic-bezier(0.25, 0.25, 0.75, 0.75);

  & > li {
    padding: 22px 32px;
  }
`;
